export const Roles = {
  alert: 'alert',
  button: 'button',
  combobox: 'combobox',
  error: 'error',
  formInput: 'form-input',
  formRadio: 'radio',
  formCheckbox: 'checkbox',
  formGroup: 'form-group',
  listbox: 'listbox',
  listItem: 'listitem',
  list: 'list',
  prefix: 'prefix',
  presentation: 'presentation',
  progress: 'progress',
  region: 'region',
  slider: 'slider',
  suffix: 'suffix',
  tab: 'tab',
  tablist: 'tablist',
  tabpanel: 'tabpanel',
  textbox: 'textbox',
  toggle: 'form-toggle',
};
